import { initTabSystem } from './utils/tabs';

document.addEventListener('DOMContentLoaded', function () {
  // ─── Video Modal ─────────────────────────────────────────────────────────────
  const playBtn = document.getElementById('hero-video-play');
  const modal = document.getElementById('video-modal');
  const modalVideo = document.getElementById('modal-video');
  const modalClose = document.getElementById('video-close');

  if (playBtn && modal && modalVideo && modalClose) {
    playBtn.addEventListener('click', function () {
      modal.classList.add('is-open');
      modalVideo.play();
      document.body.style.overflow = 'hidden';
    });

    const closeModal = function () {
      modal.classList.remove('is-open');
      modalVideo.pause();
      modalVideo.currentTime = 0;
      document.body.style.overflow = '';
    };

    modalClose.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  // ─── Research Capabilities Tabs ─────────────────────────────────────────────
  initTabSystem({
    tabsContainerSelector: '#research-tabs',
    panelsContainerSelector: '#research-content',
    tabSelector: '.research-capabilities__tab',
    panelSelector: '.research-capabilities__panel',
  });
});
